import React, {useState, useEffect} from 'react';
import {Redirect} from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import logo from '../../assets/logo.png';
import NavDropdown from 'react-bootstrap/NavDropdown';
// import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { loadDashboardSettings } from '../../redux/actions/dashboardAction';
import { trialMode, getLogoutDomain } from '../../ApiHelper';

// const HeroImage = () => <div>Hero image here</div>;

const Header = ({onSwitchClick, database}) => {
  const [schoolName, setSchoolName] = useState('');
  const [className, setClassName] = useState('');
  const [resourceLink, setResourceLink] = useState('https://essentialskills.com/resources');

  useEffect(()=>{
    if(database['error']) return <> {window.location.href=getLogoutDomain()+'login.php?haserror=true'}</>;
    if(!database['getCustomer'] || !database['getCustomer'].data || !database['getCustomer'].isLoaded) return;
    if(!database['getAllClasses'] || !database['getAllClasses'].data || !database['getAllClasses'].isLoaded) return;
    if(schoolName !== database['getCustomer'].data['NAME']){
      setSchoolName(`${database['getCustomer'].data['NAME']}`);      
    }

    // add class name to header if LTI mode
    if (sessionStorage.getItem('LTIMode') !== null) {
      let userID = sessionStorage.getItem('userID');
      if(userID && database['getAllClasses'] && database['getAllClasses'].data && database['getAllClasses'].data[userID]){
        let className = "";
        className = database['getAllClasses'].data[userID].Classname;
        setClassName(className);
      }
    }

    if(trialMode) setResourceLink('https://essentialskills.com/trial-resources');
  });
  
  //const activeStyle = { color: "#F15B2A" };
  const backgroundStyle = {
    backgroundColor:'#4267B2'
  };

  const logoStyle = {
      paddingTop: '0px',
      width: 'auto',
      height: '60px',
      //overflow: 'visible',
      //float: 'right',

      //position: 'relative',
      //left: '15%',
    
      //display: 'inline-block',
      //verticalAlign:'top'
  };

  const position = {
    position: 'absolute',
    top:'0'
  };

  if (window.location.pathname === '/viewreports') return null;

  return (<>
    <Navbar collapseOnSelect expand="lg"  variant="dark" style={backgroundStyle}>
      <Container>
        <Nav><span style={position}> <Navbar.Brand> <img src="/assets/logo.png" style={logoStyle} alt="Logo" /> {schoolName} </Navbar.Brand></span></Nav>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto">         
          </Nav>
          <Nav.Link target="_blank" href='https://essentialskills.com/feedback' style={{ textDecoration: 'none', color: 'white' }} >Feedback</Nav.Link>
          <Nav.Link target="_blank" href={resourceLink} style={{ textDecoration: 'none', color: 'white' }} >Resources</Nav.Link>
          <Nav>
            {/* <button onClick={()=> onSwitchClick('Teacher') }> teacher </button>  
            <button onClick={()=> onSwitchClick('Admin') }> admin </button>   */}
            <NavDropdown style={{ textDecoration: 'none', backgroundColor: '#28a745'}} variant="light" title="Help" id="basic-nav-dropdown">
                <NavDropdown.Item target="_blank" href='https://online.essentialskills.com/docs/manual/Essential%20Skills%20online%20manual.pdf'>Manual</NavDropdown.Item>
                <NavDropdown.Item target="_blank" href='https://essentialskills.com/support-web'>Support</NavDropdown.Item>
                <NavDropdown.Item target="_blank" href='https://essentialskills.com/videos'>Help Videos</NavDropdown.Item>
            </NavDropdown>

            {/* <Link style={{ textDecoration: 'none', color: 'white' }} to={'/profile'}>         
              Account
            </Link>
            <Nav.Link href="/profile" style={{ textDecoration: 'none', color: 'white' }} >Account</Nav.Link>      */}

            <Nav.Link href={getLogoutDomain()} style={{ textDecoration: 'none', color: 'white' }} >Logout</Nav.Link>
          </Nav>
        </Navbar.Collapse>
        {/* <Route path='/viewreports' exact component={HeroImage} /> */}
      </Container>
    </Navbar>
    {className && (
      <Container>
        <div style={{ textAlign: 'right', marginRight: '15px' }}>
        <strong>Class:</strong> { className }
        </div>
      </Container>
    )}
    </>
  );
};

const mapStateToProps = state => {
  return {
      isAdmin: (state.dashboardReducer.login === 'Admin'),
      database: state.genericReducer,
 };
};

const mapDispatchToProps = dispatch => {
  return {
    onSwitchClick: id => {
      dispatch(loadDashboardSettings({login: id}));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);